import RequestBase from '../Resources/RequestBase';

export default class CompaniesSearchRequest extends RequestBase {
    constructor(success) {
        super();
        this._url = '/companies?searchTerm={searchTerm}';
        this.method = 'GET';
        this.test = true;
        this.success = success;
        this.error = 'Wrong parameters';
        this.data = {data: [
            {
                'Name': 'Capital On Tap',
                'RegistrationNumber': '109943223'
            },
            {
                'Name': 'Capital Me',
                'RegistrationNumber': '109363253'
            }
        ]};
    }
}



// WEBPACK FOOTER //
// ./src/TestResources/Companies.js